export type XMLHttpRequestBodyInit =
	| Blob
	| BufferSource
	| FormData
	| URLSearchParams
	| string;

export async function upload(
	url: string | URL,
	init?: {
		body: Document | XMLHttpRequestBodyInit;
		method?: "POST" | "PUT";
		headers?: Record<string, string>;
		onProgress?: (progress: number) => void;
	},
): Promise<boolean> {
	const xhr = new XMLHttpRequest();
	return await new Promise((resolve, reject) => {
		xhr.upload.addEventListener("progress", (event) => {
			if (event.lengthComputable) {
				if (init?.onProgress) {
					init.onProgress(event.loaded / event.total);
				}
			}
		});
		xhr.addEventListener("error", () => {
			reject(new Error("Upload failed"));
		});
		xhr.addEventListener("abort", () => {
			reject(new Error("Upload failed"));
		});
		xhr.addEventListener("loadend", () => {
			resolve(xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300);
		});
		xhr.open(init?.method ?? "PUT", url, true);
		for (const [key, value] of Object.entries(init?.headers ?? {})) {
			xhr.setRequestHeader(key, value);
		}
		xhr.send(init?.body);
	});
}
